import getAxios from "./axiosService";

let listService = {
  //视频首页
  getVodHome() {
    return new Promise((resolve, reject) => {
      let axios = getAxios(true);
      axios.get('/api/vod/index')
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get vod with error', res);
            reject();
          }
        })
    })
  },
  //视频首页
  // getVodCategory(i, p) {
  //   const id = i
  //   const page = p
  //   return new Promise((resolve, reject) => {
  //     let axios = getAxios(true);
  //     axios.get('/api/vod/page/'+ id +'/' + page)
  //       .then(res => {
  //         if(res.status === 200) {
  //           resolve(res.data);
  //         }
  //         else {
  //           console.error('Get vod category with error', res);
  //           reject();
  //         }
  //       })
  //   })
  // },
  getVodHome() {
    return new Promise((resolve, reject) => {
      let axios = getAxios(false);
      axios.get('/api/vod/index_v2')
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get vod with error', res);
            reject();
          }
        })
    })
  },
  //分类内容
  getLatest(category,page,size) {
    let _size = size ? size : 10
    return new Promise((resolve, reject) => {
      let axios = getAxios(true);
      //axios.get(`/api/book/recent_update?currentPage=${target}`)
      axios.get(`/api/vod/page/${category}/${page}?pageSize=${_size}`)
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get vod lists with error', res);
            reject();
          }
        })
    })
  },
//换一批
getRefreshList(category,page) {
  return new Promise((resolve, reject) => {
    let axios = getAxios(true);
    axios.get(`/api/vod/shelf/${category}/${page}`)
      .then(res => {
        if(res.status === 200) {
          resolve(res.data);
        }
        else {
          console.error('Get vod lists with error', res);
          reject();
        }
      })
  })
},
  //排行榜
  getMoreRank(rankType,category,page) {
    return new Promise((resolve, reject) => {
      let axios = getAxios(false);
      axios.get(`/api/vod/rank?rankType=${rankType}&typeId=${category}&currentPage=${page}`)
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get vod lists with error', res);
            reject();
          }
        })
    })
  },

  //每日更新 + 橱窗
  getVodHomeLatest(category,page) {
    return new Promise((resolve, reject) => {
      let axios = getAxios(false);
      axios.get(`/api/vod/page/${category}/${page}`)
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get vod lists with error', res);
            reject();
          }
        })
    })
  },

  getVodDetail(cid){
    return new Promise((resolve, reject) => {
      let axios = getAxios(false);
      axios.post('/api/vod/watch', {}, {
        params: {
          vodId: cid
        }
      }).then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get vod lists with error', res);
            reject();
          }
        })

    })
  },
  getVodShelf(p) {
    const page = p
    return new Promise((resolve, reject) => {
      let axios = getAxios(false);
      axios.get('/api/vod/order/page/'+ page)
        .then(res => {
          if(res.status === 200) {
            console.log(res.data)
            resolve(res.data);
          }
          else {
            console.error('Get vod category with error', res);
            reject();
          }
        })
    })
  },
  buyVod(cid){
    return new Promise((resolve, reject) => {
      let axios = getAxios(false);
      axios.post('/api/vod/buy', {}, {
        params: {
          vodId: cid
        }
      }).then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            console.error('Get vod lists with error', res);
            reject();
          }
        })

    })
  }

};



export default listService



// WEBPACK FOOTER //
// ./src/services/vodService.js